module.exports = __webpack_public_path__ + "fonts/Slidexiaxing-Regular.2268941c.ttf";